import React from "react"
import styled from 'styled-components';
import { Button } from 'semantic-ui-react';

const StyledBtnGroup = styled(Button.Group)`

  & .ui.basic.button {
    box-shadow: 0 0 0 1px rgba(34,36,38,.15) inset !important;
  }

  & .ui.basic.button:hover {
    background: #fff!important;
    color: rgba(0,0,0,.8)!important;
    -webkit-box-shadow: 0 0 0 1px rgba(34,36,38,.35) inset, 0 0 0 0 rgba(34,36,38,.15) inset !important;
    box-shadow: 0 0 0 1px rgba(34,36,38,.35) inset, 0 0 0 0 rgba(34,36,38,.15) inset !important;
  }

`;

interface DivWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  [key: string]: any
}

export class SearchByButtonsStyle extends React.Component<DivWrapperProps> {
  render() {
    const {children, ...rest} = this.props;
    return <StyledBtnGroup {...rest}>
      {children}
    </StyledBtnGroup>;
  }
}

export default SearchByButtonsStyle;
